import Phaser from "phaser"
import { initFont, onFontInit } from "../../utils/fonts";
import { generateRandomNumber, randomWithProbabilities } from "../../utils/helpers";



export default class Introduction extends Phaser.Scene {

    init() {
        initFont();
    }
    preload() {
        this.load.script('webfont', 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js');
        this.load.audio('bg-sound', require('../../assets/sounds/BGSound.mp3'));
        this.load.audio('click-sound', require('../../assets/sounds/click.mp3'));

        this.load.image("intro-background", require('./assets/Background.png'));
        this.load.image("intro-app-logo", require('./assets/Logo.png'));
        this.load.image("intro-game-logo", require('./assets/game_logo_02.png'));
        this.load.image("intro-game-sponsor", require('./assets/SponsorV3.png'));

        this.load.image("intro-grass-01", require('./assets/grass04.png'));
        this.load.image("intro-grass-02", require('./assets/grass05.png'));
        this.load.image("intro-bunny", require('./assets/gold_bunny.png'));
        this.load.image("intro-otter", require('./assets/otter.png'));



        this.load.image("intro-play-btn", require('./assets/PlayBtn.png'));
        this.load.image("intro-instructions-btn", require('./assets/InstructionsBtn.png'));
        this.load.image("intro-leaderboard-btn", require('./assets/LeaderboardBtn.png'));
        this.load.image("intro-prizes-btn", require('./assets/PrizesBtn.png'));
        this.load.image("intro-sound-btn", require('./assets/Sound.png'));

    }
    create() {
        
        onFontInit(['Rockridge'], () => {

            this.bgSound = this.sound.add('bg-sound', { volume: 0.5, loop: true });
            this.clickSound = this.sound.add('click-sound', { volume: 0.5, loop: false });
            this.bgSound.play();

            this.canvasWidth = this.game.config.width;
            this.canvasHeight = this.game.config.height;

            this.add.image(0, 0, "intro-background").setOrigin(0, 0);
            this.add.image(20, 20, "intro-app-logo").setOrigin(0, 0);
            this.add.image(this.canvasWidth / 2, 450, "intro-game-logo")

            this.soundBtn =this.add.image(this.canvasWidth - 100, 100, "intro-sound-btn")
            this.gameStartBtn = this.add.image(this.canvasWidth / 2, 900, "intro-play-btn")
            this.instructionBtn = this.add.image(this.canvasWidth / 2, 1050, "intro-instructions-btn")
            this.leaderboardBtn = this.add.image(this.canvasWidth / 2, 1200, "intro-leaderboard-btn")
            this.prizesBtn = this.add.image(this.canvasWidth / 2, 1350, "intro-prizes-btn")



            this.otter = this.add.image(900, 1550, "intro-otter")

            const shape = this.make.graphics();
            shape.fillStyle(0xffffff);
            shape.beginPath();
            shape.fillRect(610, 1700, 1080, 1920);
            const mask = shape.createGeometryMask();
            mask.invertAlpha = true
            this.otter.setMask(mask);

            this.add.image(1000, 1650, "intro-grass-01").setScale(1.5)

            this.bunny = this.add.image(200, 1700, "intro-bunny")
            this.add.image(300, 1850, "intro-grass-02").setScale(1.5)

            this.addNPCTweens(this.otter, 1850);
            this.addNPCTweens(this.bunny, 2100);


            this.add.image(this.canvasWidth/2, 1830, "intro-game-sponsor").setScale(0.6).setOrigin(0.5, 0.5);


            // this.gameStartBtn = this.add.text(100, 700, 'Start Game', { fontFamily: 'Rockridge', fontSize: 80, color: '#ff0000' }).setShadow(2, 2, "#333333", 2, false, true);
            // this.instructionBtn = this.add.text(100, 850, 'Instruction', { fontFamily: 'Rockridge', fontSize: 80, color: '#ff0000' }).setShadow(2, 2, "#333333", 2, false, true);
            // this.leaderboardBtn = this.add.text(100, 1000, 'Leaderboard', { fontFamily: 'Rockridge', fontSize: 80, color: '#ff0000' }).setShadow(2, 2, "#333333", 2, false, true);
            // this.prizesBtn = this.add.text(100, 1150, 'Prizes', { fontFamily: 'Rockridge', fontSize: 80, color: '#ff0000' }).setShadow(2, 2, "#333333", 2, false, true);

            this.gameStartBtn.setInteractive();
            this.instructionBtn.setInteractive();
            this.leaderboardBtn.setInteractive();
            this.prizesBtn.setInteractive();

            this.soundConfig();

            this.gameStartBtn.on('pointerdown', (pointer) => {
                this.clickSound.play();
                this.scene.start('CountDown');
                this.bgSound.stop();
            });

            this.instructionBtn.on('pointerdown', (pointer) => {
                this.clickSound.play();
                this.scene.start('Instruction');
            // this.scene.start('GameOver', { s: 200});
                this.bgSound.stop();
                
            });

            this.leaderboardBtn.on('pointerdown', (pointer) => {
                this.scene.start('Leaderboard');
                this.clickSound.play();
                this.bgSound.stop();
            });

            this.prizesBtn.on('pointerdown', (pointer) => {
                this.clickSound.play();
                this.scene.start('Prizes');
                this.bgSound.stop();
            });

            this.soundBtn.setInteractive();
            this.soundBtn.on('pointerdown', (pointer) => {
                if(this.game.config.soundSetting){
                    this.game.config.soundSetting = false;
                }else{
                    this.game.config.soundSetting = true;
                }
                this.soundConfig();
            });
        })
    }

    soundConfig(){
        if(this.game.config.soundSetting){
            this.soundBtn.setTint(0xffffff);
        }else{
            this.soundBtn.setTint(0x000000);
        }
        this.clickSound.mute = !this.game.config.soundSetting;
        this.bgSound.mute = !this.game.config.soundSetting;
    }

    update() {

    }

    addNPCTweens(npcImage, y) {
        this.tweens.add({
            targets: npcImage,
            y: y,
            loop: -1,
            delay: generateRandomNumber(1000, 3000),
            duration: generateRandomNumber(300, 800),
            hold: generateRandomNumber(1000, 3000),
            yoyo: true,
            loopDelay: generateRandomNumber(1000, 2000)
        });
    }

}